import styled from "styled-components";
import BlogIcon from "@public/assets/icon/blog.svg"
import YoutubeIcon from "@public/assets/icon/youtube.svg"
import InstagramIcon from "@public/assets/icon/instagram.svg"
import FacebookIcon from "@public/assets/icon/facebook.svg"
import {SIZES} from "@/components/constants";
import { useRouter, usePathname } from "@/i18n/navigation";
import FloatButton from "@/components/FloatButton";
import {useSelector} from "react-redux";

const Footer = () => {
    const router = useRouter();
    const pathName = usePathname();
    const langData = useSelector(state => state.language.data);
    const isHideFloat = pathName.indexOf("help-center") > -1;
    return(
        <>
            {
                langData &&
                <>
                    <FooterWrap>
                        <div className={"container"}>
                            <div className={"service"}>
                                <ul className={"sub-list"}>
                                    <li onClick={() => {
                                        window.open("https://blog.naver.com/syntrovalley", "_blank", "noopener,noreferrer");
                                    }}><p><img src={BlogIcon?.src} alt={"블로그 아이콘"}/></p></li>
                                    <li onClick={() => {
                                        window.open("https://www.youtube.com/@syntrovalley", "_blank", "noopener,noreferrer");
                                    }}><p><img src={YoutubeIcon?.src} alt={"유튜브 아이콘"}/></p></li>
                                    <li onClick={() => {
                                        window.open("https://www.instagram.com/syntrovalley/", "_blank", "noopener,noreferrer");
                                    }}><p><img src={InstagramIcon?.src} alt={"인스타그램 아이콘"}/></p></li>
                                    <li onClick={() => {
                                        window.open("https://www.facebook.com/syntrovalley/?rdid=PXOqXMPVNCgkNXxd", "_blank", "noopener,noreferrer");
                                    }}><p><img src={FacebookIcon?.src} alt={"페이스북 아이콘"}/></p></li>
                                </ul>
                                <div className={"privacy"} onClick={() => {
                                    router.push("/privacy");
                                }} dangerouslySetInnerHTML={{__html: langData["footer-privacy-policy"]}}/>
                            </div>
                            <div className={"line"}></div>
                            <ul className={"description"}>
                                <li dangerouslySetInnerHTML={{__html: langData["footer-syntrovalley"]}}/>
                                <li dangerouslySetInnerHTML={{__html: langData["footer-business-reg-num"]}}/>
                                <li dangerouslySetInnerHTML={{__html: langData["footer-ceo-name"]}}/>
                                <li dangerouslySetInnerHTML={{__html: langData["footer-address"]}}/>
                                <li dangerouslySetInnerHTML={{__html: langData["footer-tel"]}}/>
                                <li onClick={() => {
                                    window.open("mailto:info@syntrovalley.com", "_blank", "noopener,noreferrer");
                                }}>
                                    <p className={"point"} dangerouslySetInnerHTML={{__html: langData["footer-email"]}}/>
                                </li>
                            </ul>
                            <p className={"copy-right"} dangerouslySetInnerHTML={{__html: langData["all-rights-reserved"]}}/>
                        </div>
                    </FooterWrap>
                    {!isHideFloat && <FloatButton data={langData}/>}
                </>
            }

        </>
    )
}
const FooterWrap = styled.footer`
    padding: 80px 0;
    background-color: #07903a;

    .container {
        width: 100%;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        gap: 24px;
        padding: 0 24px;

        .service {
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-direction: column;
            width: 100%;
            gap: 24px;

            .sub-list {
                display: flex;
                align-items: center;
                gap: 24px;

                li {
                    cursor: pointer;
                }
            }

            .privacy {
                font-weight: 500;
                color: #fff;
                cursor: pointer;
            }
        }

        .line {
            width: 100%;
            height: 1px;
            background-color: #fff;
        }

        .description {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            color: #fff;

            li {
                line-height: 25px;
                font-weight: 500;
                font-size: 16px;
                text-align: center;

                p {
                    display: inline-block;
                    &.point{
                        cursor: pointer;
                    }
                }
            }
        }

        .copy-right {
            width: 100%;
            font-size: 16px;
            line-height: 24px;
            font-weight: 500;
            color: #fff;
            text-align: center;
        }
    }

    @media (min-width: ${SIZES.MOBILE}) {
        .container {
            max-width: 640px;

            .service {
                flex-direction: row;
            }
        }
    }
    @media (min-width: ${SIZES.MOBILE_L}) {
        .container {
            max-width: 768px;

            .description {
                align-items: flex-start;
            }
        }
    }
    @media (min-width: ${SIZES.TABLET}) {
        .container {
            max-width: 1024px;
            padding: 0 40px;
            .copy-right{
                text-align: start;
            }
        }
    }
    @media (min-width: ${SIZES.TABLET_L}) {
        .container {
            max-width: 1280px;
        }
    }
    @media screen and (min-width: ${SIZES.PC}) {
        .container {
            max-width: 1536px;
        }
    }
`
export default Footer